<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                @click="openModal('create')"
              >
                <em class="fa fa-plus"></em>
                {{ $t('common_words.add_area') }}
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
          <el-dialog
            top="2%"
            v-if="isShow()"
            :title="nameAreasSelected"
            :visible.sync="modals.read"
            width="50%"
          >
            <p>
              {{ $t('common_words.selected_record_info') }}
            </p>
            <div class="card" v-if="rowData">
              <div class="card-body" v-if="rowData">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.name') }}:</strong>
                        </h6>
                        {{ rowData.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{
                              $t('common_words.associated_companies')
                            }}:</strong
                          >
                        </h6>
                        <span
                          v-for="(business, index) in rowData.business"
                          :key="business.name"
                        >
                          <el-tag type="info">{{ business.name }}</el-tag>
                          <br v-if="index % 5 == 0 && index != 0" />
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer footer-date-at" v-if="rowData">
                <p class="text-muted">
                  <small
                    >{{ $t('common_words.created_on') }}:
                    {{ rowData.created_at }}</small
                  >
                </p>
              </div>
            </div>
          </el-dialog>
          <el-dialog
            v-if="isCreate()"
            :title="title"
            :visible.sync="modals.create"
          >
            <form>
              <div class="row">
                <div class="col-12">
                  <fg-input
                    ref="nombre"
                    type="text"
                    :label="`${$t('common_words.name')} *`"
                    v-model="areaForm.name"
                    name="common_words.name"
                    v-validate="modelValidations.nombre"
                    :error="getError('common_words.name', true)"
                    :placeholder="`${$t('common_words.agriculture')}...`"
                  >
                  </fg-input>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group has-label">
                    <label class="text-transform-none"
                      >{{ $t('common_words.select_companies') }} *</label
                    >
                    <br />
                    <el-select
                      @change="
                        selectAllFromSelect(
                          'areaForm.businesses_id',
                          businesses
                        )
                      "
                      clearable
                      multiple
                      class="select-primary custom-width-select bus-rels shadow-sm required-business"
                      v-model="areaForm.businesses_id"
                      filterable
                      :placeholder="`${$t('common_words.select_companies')}*`"
                    >
                      <el-option
                        v-for="option in businesses"
                        class="select-primary selected-all"
                        :value="option.id"
                        :label="option.name"
                        :key="option.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </form>
            <span slot="footer" class="dialog-footer">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="closeModal('create')"
              >
                {{ $t('common_words.cancel') }}</button
              >&nbsp;
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="validate"
              >
                {{ $t('common_words.confirm') }}
              </button>
            </span>
          </el-dialog>
        </div>
        <div v-if="isIndex()">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="$t('common_words.per_page')"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              show-word-limit
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <el-table
              stripe
              :default-sort="{ prop: 'name', order: 'descending' }"
              :data="queriedData"
              style="width: 100%"
              border
            >
              <el-table-column
                type="index"
                width="80"
                align="center"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :fixed="column.fixed"
                :sortable="column.sortable"
                :align="column.align"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                min-width="90"
                prop="props.business"
                :label="$t('common_words.associated_companies')"
                align="center"
                :resizable="false"
              >
                <template slot-scope="scope">
                  <el-badge
                    class="custom-el-badge__content item"
                    v-if="scope.row.business.length > 0"
                    :hidden="scope.row.business.length == 1 ? true : false"
                    :value="200"
                    :max="scope.row.business.length - 1"
                  >
                    <el-button plain type="info" size="small">
                      {{ scope.row.business[0].name }}</el-button
                    >
                  </el-badge>
                </template>
              </el-table-column>
              <el-table-column
                v-if="isShow() || isUpdate() || isDelete()"
                :min-width="110"
                :label="$t('common_words.operations')"
                fixed="right"
                :resizable="false"
              >
                <template slot-scope="props">
                  <div class="text-center">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="$t('common_words.view')"
                      class="btn-info btn-simple btn-link custom-margin-actions"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.edit')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="handleEdit(props.$index, props.row)"
                    >
                      <em class="fa fa-edit custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="$t('common_words.delete')"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="handleDelete(props.$index, props.row)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
              {{ to }} {{ $t('table2.of') }} {{ total }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
      </card>
      <div class="row" style="padding-right: 13px; padding-left: 13px">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="exportToPDF"
            >
              <em class="fa fa-file-pdf-o"></em>
              {{ $t('common_words.export_to_pdf') }}
            </button>
          </div>
        </div>
        <div class="col-6" v-if="isExcel()">
          <div class="text-left">
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="exportToExcel"
            >
              <em class="fa fa-file-excel-o"></em>
              {{ $t('common_words.export_to_excel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { MixinNotification } from 'src/mixins/mixin-notification';
import { Pagination as LPagination } from 'src/components/index';
import configTable from './areas-table';
import Fuse from 'fuse.js';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinForm from 'src/mixins/forms/mixin-form';
import moment from 'moment';
import store from '@/store';
import SweetAlert from 'src/class/Alerts';
import i18n from '../../../../i18n';

export default {
  components: {
    LPagination,
  },

  data() {
    return {
      areaForm: {
        name: null,
        businesses_id: [],
      },
      modelValidations: {
        nombre: {
          required: true,
        },
      },
      businesses: null,
      title: null,
      Table: {},
      Search: {},
      pagination: {},
      tableColumns: [],
      modals: {
        read: false,
        create: false,
      },
      searchQuery: '',
      tableData: [],
      rowData: null,
      fuseSearch: null,
    };
  },
  computed: {
    ...configTable().Search,

    nameAreasSelected() {
      return this.$i18n.t('common_words.record_selected_threepoints');
    },
  },

  mixins: [
    MixinPermissions,
    mixinMasters,
    MixinNotification,
    MixinExport,
    MixinForm,
    MixinMenu,
  ],
  watch: {
    '$i18n.locale': ['setupTable', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },

    openModal(name) {
      if (name == 'create') {
        this.title = i18n.t('common_words.add_area');
        this.$validator.reset();
        this.areaForm = {
          name: null,
          businesses_id: [],
        };

        this.areaForm.businesses_id = this.selectElementsAsignFromModel(
          1,
          this.areaForm.businesses_id
        );
      }
      this.modals[name] = true;
    },

    closeModal(name) {
      this.modals[name] = false;
    },

    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (this.areaForm.businesses_id.length == 0) {
            for (let index of document.getElementsByClassName(
              'required-business'
            )) {
              let sel = index.getElementsByClassName('el-input__inner')[0];
              sel.focus();
              sel.classList.add('custom-has-error');
              store.dispatch('utils/removeHasError', sel);
            }
          } else this.addEditArea();
        }
      });
    },

    handleView(index, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(index, row) {
      this.title = i18n.t('common_words.area_edit') + ' ' + row.name;
      this.areaForm = Object.assign({}, row);
      this.areaForm.route = 'areas';
      this.errors.clear();
      this.modals['create'] = true;
    },

    handleDelete(index, row) {
      this.areaForm = row;
      SweetAlert.delete(
        i18n.t('common_words.area_or_state') + '' + this.areaForm.name
      ).then((result) => {
        if (result.value) this.deleteArea();
      });
    },

    addEditArea() {
      this.showHideLoading(true);
      if (this.areaForm.route == 'areas') {
        if (this.isUpdate()) {
          Axios.updateMaster(this.areaForm)
            .then((response) => {
              this.modifyTable(1, this.areaForm.id, response);
            })
            .catch((error) => {
              this.closeModal('create');
              this.showMessageErrors(error);
            });
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          this.areaForm.route = 'areas';
          Axios.saveMaster(this.areaForm)
            .then((response) => {
              this.modifyTable(0, null, response);
            })
            .catch((error) => {
              this.closeModal('create');
              this.showMessageErrors(error);
            });
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },

    deleteArea() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.areaForm.route = 'areas';
        Axios.destroyMaster(this.areaForm)
          .then((response) => this.modifyTable(2, this.areaForm.id, response))
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    exportToPDF() {
      this.PDF({ route: 'areas/pdf', name_file: 'areas.pdf' })
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportToExcel() {
      this.Excel({ route: 'areas/excel', name_file: 'areas.xlsx' })
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    setupTable() {
      const { Table, Search } = configTable();
      this.Table = Table;
      this.Search = Search;
      this.tableColumns = Table.tableColumns;
      this.pagination = Table.pagination;
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Axios.getMasters('areas/assigned')
        .then((response) => {
          this.tableData = response.data.data;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((column) => {
              return column.prop;
            }),
          });

          Axios.getMasters('businesses/only')
            .then((response1) => {
              this.businesses = this.concatAll(response1.data.data);
              this.showHideLoading();
            })
            .catch((error) => {
              this.showHideLoading();
              SweetAlert.warning(error.response.data.message);
            });
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('areas');
  },

  beforeDestroy() {
    this.deselectedItemOnMenu('areas');
  },
};
</script>
<style></style>
